<template>
    <el-dialog title="导出编码" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form size="small" >
            <el-form-item label="选择批次" :label-width="formLabelWidth">
              <el-select v-model="code_val" placeholder="-全部批次-" filterable>
                <el-option v-for="(item,index) in list" :key="index" :label="item.title" :value="item.code_batch_id"></el-option>
              </el-select>
            </el-form-item>

        </el-form>
        <el-form size="small" >
            <el-form-item label="是否使用" :label-width="formLabelWidth" >
              <el-select v-model="status">
               <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
              </el-select>
            </el-form-item>

        </el-form>

        <a v-if="showDown" :href="down_url" target="_blank">压缩包生成成功请下载</a>

        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="exportCode" :loading="loading">执行导出</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import CodeApi from '@/api/codebatch.js';
    export default {
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                loading: false,
                dialogVisible: false,
                list:{},
                code_val:'',
                options: [{
                  value: '-1',
                  label: '全部'
                }, {
                  value: '1',
                  label: '已使用'
                }, {
                  value: '0',
                  label: '未使用'
                }],
                status:'',
                showDown:false,
                down_url:''
            };
        },
        props: ['is_show_export'],
        created() {
            // console.log(this.is_show_export)
            this.dialogVisible = this.is_show_export;
            // this.getAddressList();
            this.getCodeBatch();
        },
        methods: {
            getCodeBatch(){
                let self = this;
                let Params = {}
                
                CodeApi.getCodeList(Params,true)
                    .then(data => {
                        // console.log(data)
                        self.loading = false;
                        self.list = data.data.data
                        // let formInline = data.data.list;
                        
                     
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },

            exportCode(){
                let self = this;
                let params = {};
                params.status = self.status
                params.code_val = self.code_val

                if(params.code_val == ''){
                    self.$message({
                        message: '请选择需要导出的批次',
                        type: 'error'
                    });

                    return false;
                }
                
                self.loading = true;
                
                CodeApi.exportCode(params,true)
                    .then(data => {
                        self.loading = false;
                        if (data.code == 1) {
                            // console.log(data)
                            // self.$message({
                            //     message: '恭喜你，导出成功',
                            //     type: 'success'
                            // });
                            // self.dialogFormVisible(true);
                            self.loading = false;
                            self.showDown = true
                            self.down_url = data.data.file
                        }
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },
            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit('closeDialog', {
                        type: 'success',
                        openDialog: false
                    })
                } else {
                    this.$emit('closeDialog', {
                        type: 'error',
                        openDialog: false
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/plus/codebatch/dialog/Export.vue